module.exports = __webpack_public_path__ + "static/media/it-staff_320.785405fe.jpg";